import { CommunicationSizeComponent, ComponentIds } from '@inter-ikea-core/core';
import { ErrorMessages, ProductType } from '@inter-ikea-storageone/range';
import { BehaviorParameters } from 'rangeConfig/@types';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';

const addProduct = ({ coreApi, props, rootState }: BehaviorParameters) => {
  const productId = props.coreProductIds ? props.coreProductIds[0] : props.coreProductId;
  const product = rootState.products.inMarket.find(p => p.coreProductId === productId);
  const placementResult = coreApi.products.add(productId, props.position);

  if (!placementResult.valid && placementResult.errors && placementResult.errors.length > 0) {
    const determinePlacementAttemptErrorMessage = () => {
      if (!hideNoFramesInSceneErrorMessage(coreApi)) {
        return ErrorMessages.NoFramesInScene;
      } else if (product && placementResult?.errors?.find(e => (e as any).collisions?.length > 0)) {
        const framesInScene = coreApi.entities.getByComponent(ComponentIds.FRAME_COMPONENT_ID);
        const ivar50depthFramesInScene = framesInScene?.filter(
          f =>
            f.getComponent<CommunicationSizeComponent>(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)
              ?.size?.depth === 500
        );
        if (ivar50depthFramesInScene.length > 0 && product.type === ProductType.BILLY_DESK) {
          return ErrorMessages.IvarAddingDeskTo50DepthFrame;
        } else if (product.type === ProductType.BILLY_DRAWER) {
          return ErrorMessages.IvarAddingDrawerWontFit;
        } else {
          return ErrorMessages.ItemWontFit;
        }
      }
      return null;
    };
    const placementAttemptErrorMessage = determinePlacementAttemptErrorMessage();
    if (placementAttemptErrorMessage) {
      coreApi.emit.onPlacementAttempt(placementAttemptErrorMessage);
    }
    coreApi.entities.disposeCollidingEntities(placementResult.errors);
  }
  return placementResult;
};

export default addProduct;
